import React from 'react';
import styles from './TranscriptDisplay.module.scss';

export interface ConversationSeparator {
  title: string;
}

const ConversationSeparatorComponent: React.FC<ConversationSeparator> = ({
  title,
}) => (
  <div
    role="separator"
    aria-label={title}
    className={styles.conversationSeparator}
  >
    {title}
  </div>
);

export default ConversationSeparatorComponent;
